import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import axios from "axios";
import { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";

import {
  Card,
  CardBody,
  Row,
  Col,
} from 'reactstrap';

const SummaryAnalysis = ({classroom_id, payload, resetTriger}) => {
  const [summaryLoading, setSummaryLoading] = useState(false);
  const [scoreLoading, setScoreLoading] = useState(false);
  const [webinarData, setWebinarData] = useState([]);
  const [webinarOverAllSummary, setWebinarOverAllSummary] = useState(null);
  const [webinarScoreData, setWebinarScoreData] = useState(null);
  const scores = []; // Example scores

  const [progressOptions, setProgressOptions] = useState({
    chart: {
      type: 'bar',
    },
    title: {
      text: '',
    },
    xAxis: {
      categories: [
        'Overall Webinar Quality Score',
        'Clarity Score ',
        'Webinar Coverage Score',
        'Engagement Score',
        'Student Sentiment',
        'Responsiveness Score',
        'Time Spoken by the Teacher',
        'Fluency Score',
      ],
    },
    yAxis: {
      title: {
        text: '',
      },
      max: 100,
    },
    series: [
      {
        name: 'Scores',
        color: '#fff',
        pointWidth: 15,
        data: scores.map((score) => ({
          y: score,
          color: getGradientColor(score),
        })),
        dataLabels: {
          enabled: true,
          format: '{point.y}',
          style: {
            fontSize: '12px',
            fontWeight: 'bold',
            color: '#000',
          },
        },
      },
    ],
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: true,
      chartOptions: {
        title: {
          text: 'Aggregate Session Analysis',
        },
      },
    },
  });

  // Define the helper function once
  const getGradientColor = (score) => ({
    linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
    stops:
      score < 50
        ? [
            [0, '#FFD6D6'], // light red
            [1, '#FF8A8A'],
          ]
        : score < 80
        ? [
            [0, '#FFF7CC'], // light yellow
            [1, '#FFE066'],
          ]
        : [
            [0, '#D1F7C4'], // light green
            [1, '#90EE90'],
          ],
  });

  const fetchwebinarSummaryData = async () => {
    try {
      //setLoading(true);
      // let classroom_id = 2877; 
      const classroomData = localStorage.getItem('classroom_data');
      if (classroomData) {
        let parsedData = JSON.parse(classroomData);

        if (typeof parsedData === 'string') {
          parsedData = JSON.parse(parsedData);
        }

        const firstClassroom = Array.isArray(parsedData)
          ? parsedData[0]
          : parsedData;
        classroom_id = firstClassroom.id;
      }

      if (!classroom_id) {
        setSummaryLoading(true);
        return;
      }

      const response = await axios.post(
        process.env.REACT_APP_API_LINC_FELLOW_BASE_URL + 'webinar/list_webinar',
        {
          classroom_id: classroom_id,
          mode: 'summary',
        },
      );

      const webinarSummaryData = response?.data || null;

      if (webinarSummaryData) {
        setSummaryLoading(false);
        setWebinarOverAllSummary(webinarSummaryData);
      } else {
        setWebinarOverAllSummary(null);
      }
    } catch (error) {
      console.error('Error fetching webinar summary data:', error);
    } finally {
      setSummaryLoading(false);
    }
  };

  const fetchwebinarScoreData = async () => {
    try {
      //setLoading(true);
      //   const classroomData = localStorage.getItem('classroom_data');
      //   if (classroomData) {
      //     let parsedData = JSON.parse(classroomData);

      //     if (typeof parsedData === 'string') {
      //       parsedData = JSON.parse(parsedData);
      //     }

      //     const firstClassroom = Array.isArray(parsedData)
      //       ? parsedData[0]
      //       : parsedData;
      //     classroom_id = firstClassroom.id;
      //   }

      if (!classroom_id) {
        // toast.success('Classroom ID missing', { autoClose: 3000 });
        // setScoreLoading(true);
        return;
      }

      const response = await axios.post(
        process.env.REACT_APP_API_LINC_FELLOW_BASE_URL + 'webinar/list_webinar',
        {
          classroom_id: classroom_id,
          mode: 'scores',
        },
      );

      const webinarScoreData = response?.data || null;

      if (webinarScoreData) {
        setWebinarScoreData(webinarScoreData);
        setScoreLoading(false);
        const overallSessionScore =
          webinarScoreData?.avg_overall_quality_score ?? 0;
        const clarityScore = webinarScoreData?.avg_clarity_score ?? 0;
        const webinarCoverScore = webinarScoreData?.avg_coverage_score ?? 0;
        const webinarEngagementcore =
          webinarScoreData?.avg_engagement_score ?? 0;
        const studentSentimentScore =
          webinarScoreData?.avg_student_sentiment ?? 0;
        const TimeSpokenScore = webinarScoreData?.avg_instructor_talktime ?? 0;
        const fluencyScore = webinarScoreData?.avg_fluency_score ?? 0;
        const avg_responsiveness_score =
          webinarScoreData?.avg_responsiveness_score ?? 0;

        // Update Progress Bar Options Dynamiwebinary
        setProgressOptions((prevOptions) => ({
          ...prevOptions,
          series: [
            {
              name: 'Scores',
              color: '#fff',
              pointWidth: 10,
              data: [
                {
                  y: overallSessionScore,
                  color: getGradientColor(overallSessionScore),
                },
                {
                  y: clarityScore,
                  color: getGradientColor(clarityScore),
                },
                {
                  y: webinarCoverScore,
                  color: getGradientColor(webinarCoverScore),
                },
                {
                  y: webinarEngagementcore,
                  color: getGradientColor(webinarEngagementcore),
                },
                {
                  y: studentSentimentScore,
                  color: getGradientColor(studentSentimentScore),
                },
                {
                  y: avg_responsiveness_score,
                  color: getGradientColor(avg_responsiveness_score),
                },
                {
                  y: TimeSpokenScore,
                  color: getGradientColor(TimeSpokenScore),
                },
                {
                  y: fluencyScore,
                  color: getGradientColor(fluencyScore),
                },
              ],
              dataLabels: {
                enabled: true,
                format: '{point.y}',
                style: {
                  fontSize: '12px',
                  fontWeight: 'bold',
                  color: '#000',
                },
              },
            },
          ],
        }));
      } else {
        setWebinarScoreData(null);
      }
    } catch (error) {
      console.error('Error fetching webinar score data:', error);
    } finally {
      setScoreLoading(false);
    }
  };

  useEffect(() => {
    fetchwebinarSummaryData();
    fetchwebinarScoreData();
  }, [classroom_id]);


  useEffect(() => {
        setWebinarOverAllSummary(null);
        console.warn("reset trigger")
  }, [resetTriger])
  
  if (!payload) return;

  return (
    <>
      <Card
        style={{
          marginBottom: '0px',
          borderRadius: '0px',
          padding:"0px 10px"
        }}
      >
        <CardBody>
          <Row className="g-4">
            <Col md={6} lg={6} className="mb-2">
              <Card className="mb-2 h-100 border box-shadow-none">
                <CardBody>
                  <h5 className="f-18 d-flex bold mb-3 ">Summary Analysis </h5>
                  {webinarOverAllSummary ? (
                    <div>
                      <h5 className="f-18 d-flex bold">Strengths</h5>
                      <div
                        className="mt-2"
                        dangerouslySetInnerHTML={{
                          __html:
                            webinarOverAllSummary?.strengths ||
                            '<p>No data related Strength available .</p>',
                        }}
                      />
                      <h5 className="f-18 d-flex bold">Areas of Improvement</h5>
                      <div
                        className="mt-2"
                        dangerouslySetInnerHTML={{
                          __html:
                            webinarOverAllSummary?.areas_of_improvement ||
                            '<p>No data related Improvement available </p>',
                        }}
                      />
                    </div>
                  ) : (
                    <div>No webinars available.</div>
                  )}
                </CardBody>
              </Card>
            </Col>
            <Col md={6} lg={6} className="mb-2">
              <Card className="mb-2 h-100 border box-shadow-none">
                <CardBody>
                  <div>
                    <h5 className="f-18 d-flex  bold mb-3 ">
                      Aggregated Analysis of Sessions
                    </h5>
                    {webinarOverAllSummary ? (
                      <HighchartsReact
                        highcharts={Highcharts}
                        options={progressOptions}
                      />
                    ) : (
                      <div>No webinars available.</div>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </CardBody>
      </Card>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
};

export default SummaryAnalysis;
